export const updateTimer = () => {
    localStorage.removeItem('session-time')
    localStorage.setItem('session-time', new Date().toJSON())
    return ({
        type: 'updateTimer'
    })
}

export const timerUpdated = () => {
    return ({
        type: 'timerUpdated'
    })
}

export const removeTimer = () => ({ type: 'removeTimer' })
